Ext.define('SA.data.QueryConfig', {
    singleton: true,

    create(country, locationSeries, attributes, derivedAttributes = {}) {
        var smallestGeographicUnit = SA.data.GeographicUnits.smallestIdFor(country),
            isAggregate = ({type}) => type === 'radius' || type === 'combination',
            aggregates = locationSeries.filter(isAggregate).map(mapAggregate),
            fields = attributes.map(attribute => derivedAttributes[attribute] || attribute);

        return {
            type: 'locations',
            aggregates,
            fields,
            limit: locationSeries.length,
            where: getLocations()
        };

        function getLocations() {
            var locations = locationSeries.filter(location => !isAggregate(location));

            if (locations.length) {
                return ['in', 'locationSeries', ...locations.map(({id}) => id)];
            }

            return [];
        }

        function mapAggregate(location) {
            var {type, id, locationSeries} = location,
                customLocation = SA.data.CustomLocations.get(id),
                locations = type === 'radius' ? getLocationsForRadius() : getLocationsForCombo(),
                aggregate = {
                    locationSeries: locations,

                    overrides: {
                        locationSeries: id
                    }
                };

            if (customLocation) {
                aggregate.overrides.name = customLocation.name;
                aggregate.overrides.geographicUnitName = SA.data.GeographicUnits.getUnitLabelForLocation(location);
            }

            return aggregate;

            function getLocationsForCombo() {
                return ['in', 'locationSeries', ...locationSeries];
            }

            function getLocationsForRadius() {
                var unit = location.geographicUnit || smallestGeographicUnit,
                    {radius} = location,
                    locations = locationSeries.map(location => {
                        return ['radius', unit, radius, location];
                    });

                return locations.length === 1 ? locations[0] : ['or', ...locations];
            }
        }
    }
});